module.exports = __webpack_public_path__ + "static/media/16-18.1bb82607.mp3";